export const config = {
    apiUrl : "https://xpos-backend.cyclic.app/api"
    // apiUrl : "http://localhost:49160/api"
}
